import { gql } from '@apollo/client';

export const fetchEntitlementsCountByInvoiceGroupIds = gql`
  query fetchEntitlementsCountByInvoiceGroupIds($transactionAccountId: String!, $invoiceGroupIds: [String!]!) {
    entitlementCountsForInvoiceGroupIds(
      transactionAccountId: $transactionAccountId
      invoiceGroupIds: $invoiceGroupIds
    ) {
      invoiceGroupId
      totalEntitlementsCount
    }
  }
`;
